/**
* Click to Play JS
* -----------------------------------------------------------------------------
*
* All the JS for the Click to Play component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'click-to-play',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.click-to-play .click-to-play__area' ).each( function( key, val ) {
        const image = $( this ).find( '.image-wrapper' )[0];
        let navHeight = $( '.navbar' ).height();
        if ( $( '#wpadminbar' ).length ) {
          navHeight += $( '#wpadminbar' ).height();
        }

        const screenHeight = window.innerHeight - navHeight + 40;
        const screenWidth = window.innerWidth;
        const videoToTopLeft = $( image ).offset().left * -1;
        const videoToTopRight = $( image ).offset().right * -1;
        const videoToTopPositive = $( this ).closest( '.click-to-play' ).find( '.click-to-play__intro' ).outerHeight();
        const videoToTop = videoToTopPositive * -1;
        const initialHeight = $( image ).outerHeight();
        $( image ).height( initialHeight );
        let end = '100%';
        if ( window.innerWidth < 1024 ) {
          end = '200%';
        }

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: '50% ' + ( ( window.innerHeight / 2 ) + navHeight ),
            end: '200% ' + ( ( window.innerHeight / 2 ) + navHeight ),
            scrub: 0,
            pin: true,
            // markers: true,
          },
        } );
        tl.to( image, {y: '-40px', top: 0, left: videoToTopLeft, right: videoToTopRight, width: screenWidth, height: screenHeight, ease: 'linear'}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'click-to-play', COMPONENT );
} )( app );
